import { createFileRoute } from "@tanstack/react-router";
import CityLanding from "@/pages/local/CityLanding";
import { pageHead } from "@/lib/seo-head";
import { cityBySlug, cityPath, tradeBySlug, tradePath } from "@/lib/localSeo";

export const Route = createFileRoute("/contractor-websites/$city/")({
  component: CityLanding,
  head: ({ params }) => {
    const slug = params.city;

    // This route also serves the trade hubs ("<trade>-contractors").
    if (slug.endsWith("-contractors")) {
      const trade = tradeBySlug(slug.replace(/-contractors$/, ""));
      const term = trade?.designTerm ?? `${trade?.label ?? "Contractor"} Contractor Web Design`;
      return pageHead({
        title: `${term} | Seattle & Puget Sound, WA | jaik`,
        description:
          trade?.seoDescription ??
          `Web design and local SEO built for Puget Sound ${trade?.business ?? "contractors"}. Service pages, Google Business Profile work and lead capture that fills your schedule. Free mockup.`,
        path: trade ? tradePath(trade) : "/contractor-websites",
      });
    }

    const city = cityBySlug(slug);
    if (!city) {
      return pageHead({
        title: "Contractor Web Design | Seattle & King County, WA | jaik",
        description:
          "Contractor web design and local SEO across King County and western Washington. Built to rank locally and bring in calls.",
        path: "/contractor-websites",
        noindex: true,
      });
    }

    return pageHead({
      title: `Contractor Web Design & SEO in ${city.name}, WA | jaik`,
      description: `Contractor web design and local SEO for ${city.name}, WA trades. Built to rank in ${city.name} search and turn visitors into booked jobs. Free mockup.`,
      path: cityPath(city),
    });
  },
});
